import { ReactNode } from 'react'
import { Alert, DialogContentText, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { LoadingStatus } from 'shared/types'
import { OAuthProviderConfig } from '../../LoginStepper/oauth/oauthProviders'
import AccountCard from '../AccountCard'
import {
  ProminentOAuthProviderButton,
  SectionTitle,
  StepActions,
  StepContent,
} from '../ReauthenticationDialog.style'

interface OAuthStepProps {
  provider: OAuthProviderConfig
  message: ReactNode
  notices: ReactNode
  closeButton: ReactNode
  loading: LoadingStatus
  isBusy: boolean
  onSignIn: () => void
}

const OAuthStep = ({
  provider,
  message,
  notices,
  closeButton,
  loading,
  isBusy,
  onSignIn,
}: OAuthStepProps) => {
  const { t } = useTranslation()

  return (
    <>
      <StepContent>
        <Stack spacing={2.5}>
          <DialogContentText variant="body2" color="text.secondary">
            {message}
          </DialogContentText>
          {notices}
          <div>
            <SectionTitle variant="h3">
              {t('reauthentication.account')}
            </SectionTitle>
            <Stack spacing={2}>
              <AccountCard providerName={provider.name} />
              <ProminentOAuthProviderButton
                provider={provider}
                loading={loading}
                disabled={isBusy}
                onClick={onSignIn}
              />
              <Alert severity="info">
                {t('reauthentication.oauthPopupInfo', {
                  provider: provider.name,
                })}
              </Alert>
            </Stack>
          </div>
        </Stack>
      </StepContent>
      <StepActions disableSpacing>{closeButton}</StepActions>
    </>
  )
}

export default OAuthStep
